<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="d-flex align-items-center mb-3">
            <h1 class="mr-2">لیست بج های وفاداری</h1>
            <b-button
                variant="success"
                v-b-modal.modal-badge-create-update
                @click="renderCreateModal"
            >
              افزودن بج جدید
            </b-button>
          </div>

          <b-row>
            <!-- Search -->
            <b-col cols="12">
              <div class="d-flex flex-column flex-md-row align-items-center justify-content-end">
                <b-form-group
                    class="d-inline-block w-100 mr-md-2"
                    label="جستجوی عنوان"
                    label-for="searchCommand"
                >
                  <b-form-input
                      id="searchCommand"
                      v-model="badgesFilters.title"
                      class="d-inline-block"
                      placeholder="نقره"
                      @keydown.enter="getAllBadges"
                  />
                </b-form-group>

                <b-form-group
                    class="d-inline-block w-100 mr-md-2"
                    label="ترتیب"
                    label-for="order"
                >
                  <b-form-input
                      id="order"
                      v-model="badgesFilters.order"
                      class="d-inline-block"
                      placeholder="4"
                      @keydown.enter="getAllBadges"
                  />
                </b-form-group>

                <b-button type="button" variant="primary" @click="getAllBadges">
                  اعمال
                </b-button>
              </div>
            </b-col>

            <b-col cols="12">
              <b-table
                  ref="refUserListTable"
                  class="position-relative"
                  :items="badgeList"
                  responsive
                  :fields="myTableColumns"
                  primary-key="id"
                  show-empty
                  bordered
                  striped
                  empty-text="موردی موجود نیست!"
              >
                <template #cell(colorCode)="data">
                  <div
                      class="colorCode"
                      :style="`background-color: ${data.item.colorCode}`"
                  ></div>
                </template>

                <!-- ✅ ستون جدید: DayToDown -->
                <template #cell(dayToDown)="data">
                  <template v-if="data.item.dayToDown !== null && data.item.dayToDown !== undefined">
                    {{ data.item.dayToDown }} روز
                  </template>
                  <template v-else> - </template>
                </template>

                <template #cell(percent)="data">
                  {{ data.item.percent }}%
                </template>

                <template #cell(actions)="data">
                  <feather-icon
                      v-b-modal.modal-badge-create-update
                      @click="renderUpdateBadgeModal(data.item)"
                      icon="EditIcon"
                      size="20"
                      class="text-primary cursor-pointer"
                  />
                  <feather-icon
                      v-b-modal.modal-badge-delete
                      @click="setTempBadge(data.item)"
                      icon="Trash2Icon"
                      class="text-danger cursor-pointer ml-2"
                      size="20"
                  />
                </template>
              </b-table>
            </b-col>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                  v-model="badgesFilters.pageNumber"
                  :total-rows="totalCount"
                  :per-page="badgesFilters.count"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <create-update-modal
        v-if="isRenderingCreateUpdateModal"
        @closeCreateUpdateModal="closeCreateUpdateModal"
        @loading="loading"
        @loaded="loaded"
        @fetchData="getAllBadges"
        :badgeUpdateDetails="tempBadge"
        :isUpdating="isUpdating"
    />

    <b-modal
        title="حذف بج"
        id="modal-badge-delete"
        centered
        ok-title="بله"
        cancelTitle="خیر"
        @ok="deleteASingleBadge"
    >
      <b-container>
        <span v-if="tempBadge">
          آیا از حذف بج
          <span style="font-weight: bold">{{ tempBadge.title }}</span>
          اطمینان دارید؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
import {
  GetScheduleLoyaltyTitleList,
  DeleteASingleScheduleLoyaltyTitle,
} from "@/libs/Api/ScheduleLoyaltyDiscountTitle";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CreateUpdateModal from "./CreateUpdateModal.vue";

export default {
  watch: {
    pageNumber: {
      handler() {
        this.getAllBadges();
      },
    },
  },
  mounted() {
    this.getAllBadges();
  },
  data() {
    return {
      isLoading: false,
      badgesFilters: {
        pageNumber: 1,
        count: 10,
        title: null,
        order: null,
      },
      isRenderingCreateUpdateModal: false,
      isUpdating: false,
      totalCount: null,
      badgeList: null,
      myTableColumns: [
        { key: "id", label: "شناسه بج" },
        { key: "title", label: "عنوان بج" },
        { key: "order", label: "ترتیب" },
        { key: "percent", label: "درصد تخفیف" },
        { key: "dayToDown", label: "مهلت استفاده از تخفیف" },
        { key: "colorCode", label: "رنگ برچسب" },
        { key: "actions", label: "عملیات" },
      ],

      tempBadge: null,
    };
  },
  computed: {
    pageNumber() {
      return this.badgesFilters.pageNumber;
    },
  },
  methods: {
    loading() {
      this.isLoading = true;
    },
    loaded(hasUpdate) {
      this.isLoading = false;
      if (hasUpdate) {
        setTimeout(async () => {
          await this.getAllBadges();
        }, 500);
      }
    },
    closeCreateUpdateModal() {
      this.isRenderingCreateUpdateModal = false;
      this.isUpdating = false;
      this.tempBadge = null;
    },
    async deleteASingleBadge() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteASingleScheduleLoyaltyTitle = new DeleteASingleScheduleLoyaltyTitle(_this);
        deleteASingleScheduleLoyaltyTitle.setRequestParam({ id: _this.tempBadge.id });

        await deleteASingleScheduleLoyaltyTitle.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بج با موفقیت حذف شد.",
              },
            });
            _this.tempBadge = null;
            _this.getAllBadges();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getAllBadges() {
      try {
        this.isLoading = true;
        let _this = this;
        let getScheduleLoyaltyTitleList = new GetScheduleLoyaltyTitleList(_this);
        getScheduleLoyaltyTitleList.setRequestParamDataObj(_this.badgesFilters);

        await getScheduleLoyaltyTitleList.fetch((res) => {
          const list = Array.isArray(res.data) ? res.data : [];
          _this.badgeList = list.map((x) => ({
            ...x,
            dayToDown: x.dayToDown ?? x.DayToDown ?? null,
          }));

          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    setTempBadge(badge) {
      this.tempBadge = JSON.parse(JSON.stringify(badge));
    },
    renderCreateModal() {
      this.tempBadge = null;
      this.isUpdating = false;
      this.isRenderingCreateUpdateModal = true;
    },
    renderUpdateBadgeModal(badge) {
      this.tempBadge = JSON.parse(JSON.stringify(badge));
      this.isUpdating = true;
      this.isRenderingCreateUpdateModal = true;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    CreateUpdateModal,
  },
};
</script>

<style scoped>
.colorCode {
  width: 4rem;
  height: 1.5rem;
  border: 1px solid #333333;
}
</style>
